import { render, staticRenderFns } from "./BuhActual.vue?vue&type=template&id=5275c1fe&scoped=true&"
import script from "./BuhActual.vue?vue&type=script&lang=js&"
export * from "./BuhActual.vue?vue&type=script&lang=js&"
import style0 from "./BuhActual.vue?vue&type=style&index=0&id=5275c1fe&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5275c1fe",
  null
  
)

export default component.exports